import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames/bind";
import formatId from "lib/formatId";
import Button from "lib/common/descriptorcontrols/BaseControls/Button";

export default class Pane extends React.Component {

    constructor(props) {
        super(props);
        this.handleGroupLevelSelectAll = this.handleGroupLevelSelectAll.bind(this);
    }

    componentDidUpdate(prevProps) {
        const {
            groups,
            updatePositions
        } = this.props;

        // This "action" is really a "please measure DOM" request. So it has to
        // come from here (post render), and needs to delay a tick in case the
        // render was caused by an action.
        //
        // eslint-disable-next-line no-settimeout
        setTimeout(() =>
            updatePositions(groups, prevProps.groups));
    }

    handleGroupLevelSelectAll(groupKey, itemKeys) {
        const { toggleItem } = this.props;
        itemKeys.forEach(itemKey => {
            toggleItem(groupKey, itemKey);
        });
    }

    render() {
        const {
            type,
            iconTitle,
            groups,
            scrollState,
            toggleItem,
            handleScroll,
        } = this.props;


        const isSelected = type === "selected";

        const aClasses = classNames(
            "list-group-item",
            {
                "selected": isSelected
            }
        );
        const iClasses = classNames(
            "glyphicon",
            {
                "glyphicon-remove-circle": isSelected,
                "glyphicon-plus-circle": !isSelected
            }
        );

        const groupItems = groups && groups.map(group => {
            const {
                name: groupName,
                key: groupKey,
                items
            } = group;
            const id = `two-pane-${type}-${groupKey}`;
            const kids = items.map(({
                                        key: itemKey,
                                        name,
                                    }) =>
                <a
                    href="#"
                    key={itemKey}
                    id={formatId(groupKey + "-" + itemKey, "two-pane-tree-item")}
                    className={aClasses}
                    onClick={toggleItem.bind(this, groupKey, itemKey)}
                    data-key={itemKey}
                    data-group={groupKey}
                >
                    <i
                        title={iconTitle}
                        className={iClasses}
                    />
                    {" "}
                    {name}
                </a>);

            if (kids.length > 0) {
                return (
                    <div id={id}
                         key={groupKey}
                         className="panel panel-default list-group"
                         data-group={groupKey}>
                        <div className="panel-heading" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div className="group-name">
                             {groupName}
                            </div>
                            <div>
                                {!isSelected && (
                                    <Button
                                        label="Select All"
                                        onClick={() => this.handleGroupLevelSelectAll(groupKey, items.map(({ key }) => key))}
                                        className="btn btn-xs btn-default"
                                        style={{
                                            fontSize: "10px"
                                        }}
                                        enabled
                                    />
                                )}
                            </div>
                        </div>
                        <div className="panel-body">
                            {kids}
                        </div>
                    </div>

                );
            } else {
                return null;
            }
        });

        const header = _.isEmpty(scrollState.positions) ? null :
            <div className="panel panel-default section-label">
                <div className="panel-heading">
                    {scrollState.title}
                </div>
            </div>;
        return (
            <React.Fragment>
                {header}
                <div id="selection-tree"
                     className="scroll"
                     data-spy="scroll"
                     data-target=".panel-default.section-label"
                     onScroll={handleScroll}
                     style={{ paddingTop: header ? 45 : 0 }}
                >
                    {groupItems}
                </div>
            </React.Fragment>
        );
    }
}

Pane.propTypes = {
    type: PropTypes.string.isRequired,
    iconTitle: PropTypes.string.isRequired,
    groups: PropTypes.arrayOf(
        PropTypes.shape({
            items: PropTypes.arrayOf(PropTypes.shape({
                key: PropTypes.string.isRequired,
                name: PropTypes.string.isRequired,
            })),
            key: PropTypes.string.isRequired,
            name: PropTypes.string.isRequired,
        })
    ),
    scrollState: PropTypes.object.isRequired,
    toggleItem: PropTypes.func.isRequired,
    updatePositions: PropTypes.func.isRequired,
    handleScroll: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./app/lib/common/twopanemultiselect/Pane.js